module.exports = __webpack_public_path__ + "static/media/total-vs-passive.3844904f.png";